import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import apiServices from '../../services/service';
import {
  campaignInputData,
  dropdownPayloadCampaignContact,
  dropdownPayloadCampaignLead,
} from '../../shared/constants';
import { fetchDataAndUpdateStore } from '../../redux/actions';
import { useDispatch } from 'react-redux';
const ImportCampaign = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState(null);
  const [readyToUploadFlag, setReadyToUploadFlag] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [error, setError] = useState();
  const dispatch = useDispatch();

  const handleDownload = (fileName) => {
    apiServices.downloadFileCRM(fileName, 'Campaign');
  };

  const handleFileUpload = (event) => {
    setFile(event.target.files[0]);
  };
  const handleNext = () => {
    setReadyToUploadFlag(true);
  };
  const handleCancel = () => {
    navigate('/campaigns');
  };
  function handleSubmit(event) {
    setLoading(true);
    event.preventDefault();

    const formData = new FormData();
    formData.append('CampaignFile', file);

    const config = {
      headers: { 'content-type': 'multipart/form-data' },
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        setUploadProgress(percentCompleted);
      },
    };

    apiServices
      .importCampaign(formData, config)
      .then((response) => {
        if (response.status === 200 && response.data) {
          // Check if the response data is an object indicating success
          if (
            typeof response.data === 'object' &&
            response.data.message === 'Import Campaign Successful'
          ) {
            toast.success('Campaigns imported successfully!', {
              position: 'top-right',
            });
            dispatch(
              fetchDataAndUpdateStore({ key: 'campaignList', inputData: campaignInputData })
            );
            dispatch(
              fetchDataAndUpdateStore({
                key: 'campaignDropdownLead',
                inputData: dropdownPayloadCampaignLead,
              })
            );
            dispatch(
              fetchDataAndUpdateStore({
                key: 'campaignDropdownContact',
                inputData: dropdownPayloadCampaignContact,
              })
            );
            navigate('/campaigns');
            setLoading(false);
            return;
          }
          // Otherwise, assume response.data is a CSV string that might contain errors
          const csvText = response.data;
          const lines = csvText.split('\n').filter((line) => line.trim() !== '');
          if (lines.length === 0) {
            toast.error('No data returned.', { position: 'top-right' });
            setLoading(false);
            return;
          }
          const headerLine = lines[0];
          const headers = headerLine.split(',').map((header) => header.replace(/"/g, '').trim());
          const errorsIndex = headers.indexOf('Errors');

          let hasErrors = false;
          if (errorsIndex !== -1) {
            // Loop through the rows (skip header)
            for (let i = 1; i < lines.length; i++) {
              const row = lines[i].split(',');
              const errorValue = row[errorsIndex] ? row[errorsIndex].replace(/"/g, '').trim() : '';
              if (errorValue && errorValue.toLowerCase() !== 'null') {
                hasErrors = true;
                break;
              }
            }
          }

          if (hasErrors) {
            // Create a Blob from the CSV text and trigger the download
            const blob = new Blob([csvText], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = 'campaign_import_errors.csv'; // Name of the downloaded file
            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            toast.error('Some rows have errors. Error file downloaded.', {
              position: 'top-right',
            });
          } else {
            toast.success('Campaigns imported successfully!', {
              position: 'top-right',
            });
            dispatch(
              fetchDataAndUpdateStore({ key: 'campaignList', inputData: campaignInputData })
            );
            dispatch(
              fetchDataAndUpdateStore({
                key: 'campaignDropdownLead',
                inputData: dropdownPayloadCampaignLead,
              })
            );
            dispatch(
              fetchDataAndUpdateStore({
                key: 'campaignDropdownContact',
                inputData: dropdownPayloadCampaignContact,
              })
            );
            navigate('/campaigns');
          }
          setLoading(false);
        } else {
          toast.error('An unexpected error occurred', {
            position: 'top-right',
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        if (error.response && error.response.data && error.response.data.errors) {
          const errors = error.response.data.errors;
          // Extract HTTP status code
          const status = error.response.status;

          // Loop through each error type (e.g., "EndDate") and display its messages
          Object.keys(errors).forEach((errorType) => {
            const errorMessages = errors[errorType];
            errorMessages.forEach((errorMessage) => {
              // Display each error message in the toaster
              toast.error(` ${errorMessage}`, {
                position: 'top-right',
              });
            });
          });
        } else {
        }
        setReadyToUploadFlag(false);
        setLoading(false);
      });
  }

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  useEffect(() => {
    const preventDefaultBehavior = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    document.addEventListener('dragover', preventDefaultBehavior);
    document.addEventListener('drop', preventDefaultBehavior);

    return () => {
      document.removeEventListener('dragover', preventDefaultBehavior);
      document.removeEventListener('drop', preventDefaultBehavior);
    };
  }, []);

  return (
    <div className="importLead_main">
      <div className="viewHeader">
        <h2>Import Campaigns</h2>

        <div className="button_align"></div>
      </div>
      {!readyToUploadFlag && (
        <div className="upload-container">
          <div className="upload-inner" onDrop={handleDrop} onDragOver={handleDragOver}>
            <form onSubmit={handleSubmit}>
              <div className="file-input">
                <div className="uploadContent">
                  <img src="/assets/images/fileIcon.png" alt="File Icon" />
                  {file ? <h2>{file.name}</h2> : <h2>Upload your file here.</h2>}
                </div>
                <input
                  type="file"
                  id="file-upload"
                  accept=".CSV, .XLSX"
                  required
                  onChange={handleFileUpload}
                  style={{ display: 'none' }}
                />
                <button
                  type="button"
                  onClick={() => document.getElementById('file-upload').click()}
                  className="btn btn-primary file-btn"
                >
                  Browse
                </button>
              </div>
            </form>
            <div className="">{error && <p>Error uploading file: {error.message}</p>}</div>
            <p>
              Download sample file{' '}
              <Link to="#" onClick={() => handleDownload('CampaignSampleTemplate.csv')}>
                CSV
              </Link>{' '}
              or{' '}
              <Link to="#" onClick={() => handleDownload('CampaignSampleTemplate.xlsx')}>
                XLSX
              </Link>
            </p>
          </div>

          <div className="footer-note">
            You can import up to 5000 records through an .xls, .xlsx, .vcf or .csv file. To import
            more than 5000 records at a time, use a .csv file.
          </div>
          <div className="uploadActions">
            <button className="btn btn-outline-primary me-2" onClick={handleCancel}>
              Cancel
            </button>
            <button className="btn btn-primary" onClick={handleNext} disabled={!file}>
              Next
            </button>
          </div>
        </div>
      )}

      {readyToUploadFlag && (
        <div className="importLeadFiles">
          <div className="importLeadFiles_inner">
            <div className="fileNameBlock">
              <img src="/assets/images/xls.png" alt="" width="20px" /> <p>{file && file.name}</p>
            </div>
            <div className="records_Block">
              <p>What do you want to do with the records in the file?</p>
              <div className="input-container">
                <div className="row">
                  <div className="col-12 col-sm-12 col-md-3">
                    <input
                      type="radio"
                      id="newLeads"
                      name="newLeads"
                      value="Add as new Leads"
                      checked
                    />
                    <label htmlFor="newLeads">Add as new Campaigns</label>
                  </div>
                  <div className="col-12 col-sm-12 col-md-5 disabled">
                    <input
                      type="radio"
                      id="existingLeads"
                      name="existingLeads"
                      value="Update existing Leads only"
                      disabled={true}
                    />
                    <label htmlFor="existingLeads">
                      Update existing Campaigns only <span className="red">{'(Comming Soon)'}</span>
                    </label>
                  </div>
                  <div className="col-12 col-sm-12 col-md-4 disabled">
                    <input type="radio" id="both" name="both" value="Both" disabled={true} />
                    <label htmlFor="both">
                      Both <span className="red">{'(Comming Soon)'}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="leadActions mt-4">
                <button className="btn btn-outline-primary me-2" onClick={handleCancel}>
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  disabled={!readyToUploadFlag || loading}
                  onClick={handleSubmit}
                >
                  {loading && (
                    <>
                      {' '}
                      <div className="spinner-border spinner-border-sm me-2" role="status"></div>
                    </>
                  )}
                  {loading ? 'Loading...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImportCampaign;
